import React from 'react';

// Semicircular aptitude gauge (SVG, no deps). value: 0-100 or null.
export const SuccGauge = ({ value, label, coverage, band, testId }) => {
  const v = value === null || value === undefined ? null : Math.max(0, Math.min(100, value));
  const angle = v === null ? 0 : (v / 100) * 180;
  const r = 42; const cx = 55; const cy = 52;
  const polar = (deg) => {
    const rad = ((180 - deg) * Math.PI) / 180;
    return [cx + r * Math.cos(rad), cy - r * Math.sin(rad)];
  };
  const [ex, ey] = polar(angle);
  const color = v === null ? '#c7cfd6' : v >= 75 ? '#2e9e77' : v >= 50 ? '#d9a13b' : '#c2513f';
  const bandTone = band === 'strong' ? 'text-success' : band === 'partial' ? 'text-warning' : 'text-destructive';
  return (
    <div className="flex flex-col items-center" data-testid={testId}>
      <svg width="110" height="62" viewBox="0 0 110 62">
        <path d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`} fill="none" stroke="#e8edf1" strokeWidth="9" strokeLinecap="round" />
        {v !== null && v > 0 && (
          <path d={`M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${ex} ${ey}`} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" />
        )}
        <text x={cx} y={cy - 4} textAnchor="middle" fontSize="17" fontWeight="700" fill="#1c2b36">
          {v === null ? '—' : `${Math.round(v * 10) / 10}%`}
        </text>
      </svg>
      <p className="text-[11px] font-semibold text-center leading-tight mt-0.5 max-w-[120px]">{label}</p>
      {coverage !== null && coverage !== undefined && (
        <p className={`text-[10px] ${bandTone}`}>{coverage}%</p>
      )}
    </div>
  );
};
